"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yAxisTypes = exports.whenShowGroupSearch = exports.styles = exports.regularByDisplayNameId = exports.regKeysForGroupCharts = exports.rangeTypesByKey = exports.rangeTypes = exports.rangeTypeKey = exports.packageKey = exports.maxWaterTemperature = exports.lineSettings = exports.lineColor = exports.keysWhatToShowByGroupKey = exports.keysForGroupChartsById = exports.keysForGroupCharts = exports.equipmentKey = exports.defaultLineColor = exports.defaultGroupChartParams = exports.curveTypes = exports.constDateType = exports.colors = exports.calendarParams = exports.EquipmentTypesByNumber = exports.EquipmentTypes = void 0;
var _paulCorePackage = require("paul-core-package");
const {
  ComponentTypes
} = _paulCorePackage.constants;
const packageKey = exports.packageKey = "paul_charts";
const keysForGroupCharts = exports.keysForGroupCharts = ["Pwh", "Htg"];
const regKeysForGroupCharts = exports.regKeysForGroupCharts = {
  Pwh: /^(Pwc|Pwh)[a-z]*/i,
  Htg: /^Htg[a-z]*/i
};
const keysForGroupChartsById = exports.keysForGroupChartsById = {
  Pwh: "Pwh",
  Htg: "Htg"
};
const keysWhatToShowByGroupKey = exports.keysWhatToShowByGroupKey = {
  [keysForGroupChartsById.Pwh]: {
    [ComponentTypes.PwhC]: ComponentTypes.PwhC,
    // gusty_line
    [ComponentTypes.PwhPipe]: ComponentTypes.PwhPipe,
    [ComponentTypes.PwcPoe]: ComponentTypes.PwcPoe,
    [ComponentTypes.PwhSupply]: ComponentTypes.PwhSupply
  },
  [keysForGroupChartsById.Htg]: {
    [ComponentTypes.HtgHx]: ComponentTypes.HtgHx,
    // gusty_line
    [ComponentTypes.HtgPipe]: ComponentTypes.HtgPipe,
    [ComponentTypes.HtgSub]: ComponentTypes.HtgSub,
    [ComponentTypes.HtgSys]: ComponentTypes.HtgSys,
    [ComponentTypes.HtgCc]: ComponentTypes.HtgCc,
    [ComponentTypes.HtgHs]: ComponentTypes.HtgHs
  }
};
const whenShowGroupSearch = exports.whenShowGroupSearch = 2;
const maxWaterTemperature = exports.maxWaterTemperature = 100;
const constDateType = exports.constDateType = {
  hour: "hour",
  day: "day",
  week: "week",
  month: "month",
  year: "year",
  max: "max"
};
const calendarParams = exports.calendarParams = {
  rangeType: 'rangeType',
  dateType: 'dateType',
  from: 'from',
  to: 'to'
};
const rangeTypes = exports.rangeTypes = {
  minute: "minute",
  hour: "hour",
  day: "day"
};
const rangeTypeKey = exports.rangeTypeKey = {
  hour: 1,
  day: 2,
  minute_15: 3,
  // 15 min
  minute_1: 4 // 1 min
};

const rangeTypesByKey = exports.rangeTypesByKey = {
  [rangeTypeKey.hour]: rangeTypes.hour,
  [rangeTypeKey.day]: rangeTypes.day,
  [rangeTypeKey.minute_15]: rangeTypes.minute,
  // 15 min
  [rangeTypeKey.minute_1]: rangeTypes.minute // 1 min
};

const defaultGroupChartParams = exports.defaultGroupChartParams = {
  rangeType: rangeTypeKey.hour,
  from: _paulCorePackage.functions.getFromMonth(_paulCorePackage.functions.getEndDay()),
  to: _paulCorePackage.functions.getEndDay(),
  dateType: constDateType.month,
  inProgress: false,
  isPrediction: false
};
const lineSettings = exports.lineSettings = {
  [ComponentTypes.PwhC]: {
    type: "gusty_line",
    strokeDasharray: "5, 3"
  },
  [ComponentTypes.HtgHx]: {
    type: "gusty_line",
    strokeDasharray: "5, 3"
  },
  default: {
    type: "line",
    strokeDasharray: "0"
  }
};
const curveTypes = exports.curveTypes = {
  basis: "basis",
  cardinal: "cardinal",
  catmullRom: "catmullRom",
  linear: "linear",
  monotoneX: "monotoneX",
  monotoneY: "monotoneY",
  natural: "natural",
  step: "step",
  stepAfter: "stepAfter",
  stepBefore: "stepBefore"
};
const regularByDisplayNameId = exports.regularByDisplayNameId = {
  temperature: /^1\d{2}01\d{2}$/,
  inputTemperature: /^1\d{2}01(04|08|11)$/,
  outputTemperature: /^1\d{2}01(05|09|12)$/
};
const yAxisTypes = exports.yAxisTypes = {
  temperature: "temperature",
  empty: "empty"
};

/** @todo: colors object should be deleted after installing MUI Theme and refactoring components to use theme colors */
const colors = exports.colors = {
  'main-color-cl-01': '#00205B',
  'main-color-cl-01-hover': '#002B7A',
  'main-color-cl-02': '#2D78C6',
  'main-color-cl-03': '#37AFEB',
  'main-color-cl-04': '#81D1F7',
  'main-color-cl-05': '#BBE9FF',
  'main-color-cl-06': '#E3F7FF',
  'main-color-cl-07': '#F6F8FC',
  'main-color-cl-08': '#FFFFFF',
  'main-color-cl-09': '#F3F3F3',
  'main-color-cl-10': '#212134',
  'main-color-cl-11': '#32324D',
  'main-color-cl-12': '#4A4A6A',
  'main-color-cl-13': '#666687',
  'main-color-cl-14': '#8E8EA9',
  'main-color-cl-15': '#A5A5BA',
  'main-color-cl-16': '#C0C0CF',
  'main-color-cl-17': '#DCDCE4',
  'main-color-cl-18': '#EAEAEF',
  'main-color-cl-19': '#F6F6F9',
  'main-color-cl-20': '#00BC4B',
  'main-color-cl-21': '#D02B20',
  'main-color-cl-22': '#F29D41',
  'main-color-cl-30': '#0000FF',
  'main-color-cl-31': '#1CE783',
  'main-color-cl-32': '#EFEFED',
  'main-color-cl-40': '#E5E5E7',
  'main-color-cl-90': 'rgba(#FF00FF, 0.3)',
  'main-color-cl-91': '#FF00FF',
  'main-color-cl-92': '#FCFCFD',
  'main-color-cl-93': '#FF8000',
  'main-color-cl-94': '#E71D1C',
  'main-color-cl-95': '#101828',
  'main-color-cl-96': '#000033',
  'main-color-cl-97': '#000066',
  'main-color-cl-98': '#475467',
  'main-color-cl-99': '#667085',
  'main-color-cl-100': '#98a2b3'
};

/**
 @todo: styles object should be deleted after installing MUI Theme and refactoring components to use theme colors
 **/
const styles = exports.styles = {
  transitionType: {
    primary: '.5s ease',
    secondary: '.2s ease'
  },
  borderRadius: {
    button: '8px',
    input: '8px',
    card: '10px'
  },
  boxShadow: {
    primary: '0 5px 15px rgb(0 0 0 / 0.1)',
    secondary: '0 4px 10px rgba(0, 0, 0, 0.08)'
  }
};
const defaultLineColor = exports.defaultLineColor = colors['main-color-cl-02'];
const EquipmentTypes = exports.EquipmentTypes = {
  EQUIPMENT_TYPE_NONE: 0,
  EQUIPMENT_TYPE_PWC: 1,
  EQUIPMENT_TYPE_PWC_POE: 2,
  EQUIPMENT_TYPE_PWC_PIPE: 3,
  EQUIPMENT_TYPE_PWH: 4,
  EQUIPMENT_TYPE_PWH_C: 5,
  EQUIPMENT_TYPE_PWH_PIPE: 6,
  EQUIPMENT_TYPE_PWH_SUP: 7,
  EQUIPMENT_TYPE_HTG: 8,
  EQUIPMENT_TYPE_HTG_CC: 9,
  EQUIPMENT_TYPE_HTG_SYS: 10,
  EQUIPMENT_TYPE_HTG_HX: 11,
  EQUIPMENT_TYPE_HTG_HS: 12,
  EQUIPMENT_TYPE_HTG_SUB: 13
};
const EquipmentTypesByNumber = exports.EquipmentTypesByNumber = {
  0: 'EQUIPMENT_TYPE_NONE',
  1: 'EQUIPMENT_TYPE_PWC',
  2: 'EQUIPMENT_TYPE_PWC_POE',
  3: 'EQUIPMENT_TYPE_PWC_PIPE',
  4: 'EQUIPMENT_TYPE_PWH',
  5: 'EQUIPMENT_TYPE_PWH_C',
  6: 'EQUIPMENT_TYPE_PWH_PIPE',
  7: 'EQUIPMENT_TYPE_PWH_SUP',
  8: 'EQUIPMENT_TYPE_HTG',
  9: 'EQUIPMENT_TYPE_HTG_CC',
  10: 'EQUIPMENT_TYPE_HTG_SYS',
  11: 'EQUIPMENT_TYPE_HTG_HX',
  12: 'EQUIPMENT_TYPE_HTG_HS',
  13: 'EQUIPMENT_TYPE_HTG_SUB'
};
const equipmentKey = exports.equipmentKey = {
  EQUIPMENT_TYPE_NONE: 'None',
  EQUIPMENT_TYPE_PWC: 'Pwc',
  EQUIPMENT_TYPE_PWC_POE: ComponentTypes.PwcPoe,
  EQUIPMENT_TYPE_PWC_PIPE: ComponentTypes.PwcPipe,
  EQUIPMENT_TYPE_PWH: 'Pwh',
  EQUIPMENT_TYPE_PWH_C: ComponentTypes.PwhC,
  EQUIPMENT_TYPE_PWH_PIPE: ComponentTypes.PwhPipe,
  EQUIPMENT_TYPE_PWH_SUP: ComponentTypes.PwhSupply,
  EQUIPMENT_TYPE_HTG: 'Htg',
  EQUIPMENT_TYPE_HTG_CC: ComponentTypes.HtgCc,
  EQUIPMENT_TYPE_HTG_SYS: ComponentTypes.HtgSys,
  EQUIPMENT_TYPE_HTG_HX: ComponentTypes.HtgHx,
  EQUIPMENT_TYPE_HTG_HS: ComponentTypes.HtgHs,
  EQUIPMENT_TYPE_HTG_SUB: ComponentTypes.HtgSub
};
const lineColor = exports.lineColor = {
  middleLine: '#1CE783',
  predictionColor: '#0000FF'
};